<div class="flex-column gap pt-2" style="max-width: 30rem;">
    <app-number-input
        [formField]="formFields.retentionDays"
        [useGrouping]="false"
        helpText="organization-settings.trashSettings.fields.retentionDaysHelp"
        label="organization-settings.trashSettings.fields.retentionDays"
    ></app-number-input>

    <div class="text-color-secondary">
        {{ 'organization-settings.trashSettings.fields.minimumRetentionDays' | translate: { days: minimumRetentionDays() } }}
    </div>

    <div class="dialogButtons">
        <app-save-button
            [disabled]="!formFields().dirty() || formFields().invalid()"
            (clickEvent)="save()"
        ></app-save-button>
    </div>
</div>
